import { module } from 'angular';

import { State } from './';
import {
  default as socialNetworkActionsName,
  SocialNetworkActions,
} from './components/social-network-actions/social-network-actions.component';
import {
  default as socialNetworkBannerName,
  SocialNetworkBanner,
} from './components/social-network-banner/social-network-banner.component';
import { default as socialNetworkInfoName, SocialNetworkInfo } from './components/social-network-info/social-network-info.component';
import {
  default as socialNetworkQualificationTabActionsName,
  SocialNetworkQualificationTabActions,
} from './components/social-network-qualification-tab-actions/social-network-qualification-tab-actions.component';
import {
  default as socialNetworkQualificationActions,
  SocialNetworkQualificationActions,
} from './components/social-network-qualifications-actions/social-network-qualification-actions.component';
import {
  default as socialNetworkQualification,
  SocialNetworkQualification,
} from './components/social-network-qualifications/social-network-qualification.component';
import {
  default as socialNetworkTransferActionsName,
  SocialNetworkTransferActions,
} from './components/social-network-transfer-actions/social-network-transfer-actions.component';
import {
  default as socialNetworkTransferWorkspaceName,
  SocialNetworkTransferWorkspace,
} from './components/social-network-transfer/social-network-transfer-workspace.component';
import {
  default as socialNetworkWorkspace,
  SocialNetworkWorkspace,
} from './components/social-network-workspace/social-network-workspace.component';
import { default as socialNetworkActionsService, SocialNetworkActionsService } from './services/social-network-actions.service';
import { default as socialNetworkFrameService, SocialNetworkFrameService } from './services/social-network-frame.service';
import { default as socialNetworkTabService, SocialNetworkTabService } from './services/social-network-tab.service';

export default module('contact.agent.contact-view.social-network', [State])
  .component(socialNetworkWorkspace, new SocialNetworkWorkspace())
  .component(socialNetworkBannerName, new SocialNetworkBanner())
  .component(socialNetworkActionsName, new SocialNetworkActions())
  .component(socialNetworkInfoName, new SocialNetworkInfo())
  .component(socialNetworkQualificationActions, new SocialNetworkQualificationActions())
  .component(socialNetworkQualification, new SocialNetworkQualification())
  .component(socialNetworkQualificationTabActionsName, new SocialNetworkQualificationTabActions())
  .component(socialNetworkTransferActionsName, new SocialNetworkTransferActions())
  .component(socialNetworkTransferWorkspaceName, new SocialNetworkTransferWorkspace())
  .service(socialNetworkActionsService, SocialNetworkActionsService)
  .service(socialNetworkTabService, SocialNetworkTabService)
  .service(socialNetworkFrameService, SocialNetworkFrameService).name;
